import React, { useEffect, useState } from 'react';
import {
    Box, Container, createStyles, Dialog, FormControl, Grid, InputLabel, makeStyles, MenuItem, Select,
    TextField, Theme, IconButton, FormHelperText, DialogActions
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContentText from "@material-ui/core/DialogContentText";
import useCommonApi from '../../api/useCommonApi';
import CloseIcon from '@material-ui/icons/Close';
import { useSnackbar } from 'notistack';
import { ApplicationState } from '../../redux/reducers';
import { connect } from "react-redux"
import { enums } from "../../enums/enums";
import { validarRfc } from "../../blocks/utility";
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';

interface Props {
    abierto: boolean
    confirmar: () => void
    cerrar: () => void
    cliente: any
    usuario: any
    clienteDistribuidor: any
    setDatos: (datos: any) => void,
}
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        principal: {
            backgroundColor: "#fff",
            margin: "0px",
            padding: "10px",
        },
        container: {
            backgroundColor: "#e5e5e5",
        },
        text: {
            backgroundColor: "#fff",
        },
        div_rfc: {
            width: '100%',
        },
        label: {
            fontSize: '18px',
        },
        direccion: {
            fontSize: '14px',
            fontWeight: 600
        },
        icon: {
            width: "40px",
            height: "40px",
            minWidth: "40px",
            borderRadius: "20px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "center",
            paddingTop: "5px"
        },
        actions: {
            textAlign: "center",
            width: "100%",
            display: "block",
            padding: "30px 0px",
        },
        button: {

            backgroundColor: "#00653b",
            color: "#fff"
        },
        table: {
            minWidth: 650,
        },
        padding: {
            padding: "10px 0px"
        },
        iconSearch: {
            width: "30px",
            height: "30px",
            minWidth: "30px",
            borderRadius: "15px",
            backgroundColor: "#19754e",
            color: "#fff",
            textAlign: "right",
        },
        paper: {
            position: 'absolute',
            width: 400,
            backgroundColor: "#fff",
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
            fontFamily: "Roboto"
        },
    }),
);

const DatosComplementarios = ({ abierto, cerrar, confirmar, cliente, clienteDistribuidor, setDatos }: Props) => {

    const classes = useStyles();
    const apiSource = useCommonApi();
    const [tipoPersonaId, setTipoPersonaId] = useState(0);
    const [tiposPersona, setTiposPersona] = useState<any[]>([]);
    const [idFiscal, setIdFiscal] = useState('');
    const [rfc, setRFC] = useState('');
    const [residenciaFiscalId, setResidenciaFiscalId] = useState('');
    const [residenciasFiscales, setResidenciasFiscales] = useState<any[]>([]);
    const [rfcValido, setRFCValido] = useState(true);
    const { enqueueSnackbar } = useSnackbar();
    const personaRazonSocial = enums.tipoPersonaRazonSocial;

    const [formularioValido, setFormularioValido] = useState(true);
    const [isDisabledNRF, setIsDisabledNRF] = useState<boolean>(false);

    const validarDatos = () => {

        if (tipoPersonaId == 0 || !rfc || !rfcValido) {
            setFormularioValido(false);
            return;
        }

        if (tipoPersonaId == 5 && (residenciaFiscalId == '' || idFiscal == '' || residenciaFiscalId == '0' || idFiscal == '0')) {
            setFormularioValido(false);
            return;
        }

        if (tipoPersonaId === 5 && residenciaFiscalId === "MEX") {
            let message=traducirMessage(292); //"Para clientes extranjeros la clave de país contenida deberá ser distinta a México";
            enqueueSnackbar(message, { variant: "error" });
            return;
        }

        setFormularioValido(true);
        guardaClienteDistribuidorComplemento().then(response => {
            if (response.clienteDistribuidorComplementoID === 0) {
                enqueueSnackbar(traducirLabel(269), { variant: "error" });
                return;
            }

            let newData = clienteDistribuidor;
            newData.clienteDistribuidorComplementos = {
                clienteDistribuidorComplementoID: response.clienteDistribuidorComplementoID,
                clienteDistribuidorID: clienteDistribuidor.clienteDistribuidorID,
                clienteID: cliente.id,
                numeroIdentificaciónFiscal: idFiscal,
                residenciaFiscal: residenciaFiscalId,
                rfc: rfc,
                tipoPersonaID: tipoPersonaId,
            };

            setDatos(newData);
            confirmar();
        });
    }

    const handleChangeTipoPersona = (event: React.ChangeEvent<{ value: unknown }>) => {
        const value = Number(event.target.value);

        setRFC('');

        if (value === personaRazonSocial.particular || value === personaRazonSocial.extranjero) {
            setRFC(value === personaRazonSocial.particular ? enums.tipoRfc.particular : enums.tipoRfc.extranjero);
            setRFCValido(true);

            setResidenciaFiscalId(
                typeof event.target.value === 'string'
                    ? event.target.value : ''
            );

            setIdFiscal(                
                typeof event.target.value === 'string'
                ? event.target.value : ''
            );
        }

        if (value == 5 && (residenciaFiscalId === '' || residenciaFiscalId === '0' || idFiscal == '')) {
            setIsDisabledNRF(false);
            setResidenciaFiscalId(
                typeof event.target.value === 'string'
                    ? event.target.value : '0'
            );
        }
        if(value!==personaRazonSocial.extranjero){
            setIsDisabledNRF(true);
            setResidenciaFiscalId(
                typeof event.target.value === 'string'
                    ? event.target.value : ''
            );

            setIdFiscal(                
                typeof event.target.value === 'string'
                ? event.target.value : ''
            );
        }

        if (value === personaRazonSocial.fisica || value === personaRazonSocial.gubernamental || value === personaRazonSocial.moral || value === personaRazonSocial.particular) {
            setIsDisabledNRF(true);
            setResidenciaFiscalId(
                typeof event.target.value === 'string'
                    ? event.target.value : ''
            );

            setIdFiscal(                
                typeof event.target.value === 'string'
                ? event.target.value : ''
            );
        }

        setTipoPersonaId(value);
    };

    const setClienteDistribuidorComplemento = (): any => {
        return {
            clienteDistribuidorComplementoID: 0,
            clienteID: cliente.id,
            clienteDistribuidorID: clienteDistribuidor.clienteDistribuidorID,
            rfc: rfc,
            tipoPersonaID: tipoPersonaId,
            numeroIdentificaciónFiscal: idFiscal,
            residenciaFiscal: residenciaFiscalId
        }
    }

    const guardaClienteDistribuidorComplemento = async () => {
        const result = await apiSource.postAsync<any>("cliente-distribuidor-complemento", setClienteDistribuidorComplemento());
        return result;
    };

    const handleChangeResidenciaFiscal = (event: React.ChangeEvent<{ value: unknown }>) => {
        setResidenciaFiscalId(
            typeof event.target.value === 'string'
                ? event.target.value : ''
        );
    };

    const getResidenciasFiscales = async () => {
        const result = await apiSource.obtenerAsync<any>("solicitud-servicio/get-catalogo-residencia-fiscal",{username: localStorage.getItem("usuario_nombre")});
        return result;
    };
    const getCatalogos = async (url) => {
        const result = await apiSource.obtenerAsync<any>(url);
        return result;
    };
    const validateRFC = (e: any) => {
        const rfcValido = validarRfc(e.target.value, tipoPersonaId);
        setRFCValido(rfcValido);
    }

    useEffect(() => {

        getResidenciasFiscales().then(data => {
            setResidenciasFiscales(data);
        });

        getCatalogos("/tipo-persona/many").then(data => {
            setTiposPersona(data);
        });
    }, []);

    return (<>
        <Dialog open={abierto} maxWidth={"md"} fullWidth={true} onClose={cerrar}>
            <DialogTitle >
                <Box display="flex" alignItems="center">
                    <Box>
                    </Box>
                    <Box flexGrow={1} textAlign="center">
                        {/* Datos Complementarios */
                            traducirLabel(68)}
                    </Box>
                    <Box>
                        <IconButton onClick={cerrar}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </Box>
            </DialogTitle>

            <DialogContent >
                <DialogContentText>
                    <Container maxWidth="xl"  >
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <FormControl required={true} fullWidth variant="outlined" className={classes.padding}>
                                    <InputLabel htmlFor="tipoPersona" >
                                        {/* Tipo Persona */
                                            traducirLabel(304)}
                                    </InputLabel>
                                    <Select
                                        id="tipoPersona"
                                        onChange={handleChangeTipoPersona}
                                        value={tipoPersonaId}
                                    >
                                        <MenuItem key={0} value={0}>
                                            {/* --Seleccione-- */
                                                traducirLabel(323)}
                                        </MenuItem>
                                        {tiposPersona !== null && localStorage.getItem("idioma") === 'en-US' && tiposPersona.map((option) => (
                                                <MenuItem key={option.id} value={option.id}>
                                                    {option.etiquetaTipoPersona.nombre}
                                                </MenuItem>
                                        ))}
                                        {tiposPersona !== null && localStorage.getItem("idioma") !== 'en-US' && tiposPersona.map((option) => (
                                            <MenuItem key={option.id} value={option.id}>
                                                {option.nombre}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <FormHelperText error >{tipoPersonaId === 0 && !formularioValido ? `${traducirLabel(25)}` : ''}</FormHelperText>
                            </Grid>

                            <Grid item xs={12}>
                                <TextField className={classes.padding} fullWidth id="rfc" variant="outlined" label={traducirLabel(268)}
                                    required={true}
                                    value={rfc}
                                    disabled={!tipoPersonaId || tipoPersonaId === personaRazonSocial.particular || tipoPersonaId === personaRazonSocial.extranjero}
                                    onKeyUp={validateRFC}
                                    onChange={e => setRFC(e.target.value)}
                                    error={rfc === "" && !formularioValido}
                                    helperText={rfc === "" && !formularioValido ? `${traducirLabel(25)}` : ''}
                                    inputProps={{ maxLength: tipoPersonaId === personaRazonSocial.moral ? 12 : 13 }} />
                                <FormHelperText error >{!rfcValido && !formularioValido ? 'RFC no válido' : ''}</FormHelperText>
                            </Grid>

                            <Grid item xs={12}>
                                <TextField className={classes.padding} fullWidth id="rfc" variant="outlined"
                                    label={traducirLabel(215)}
                                    value={idFiscal}
                                    onChange={e => setIdFiscal(e.target.value)}
                                    required={tipoPersonaId == 5}
                                    error={(idFiscal === "" || idFiscal === null || idFiscal === undefined) && tipoPersonaId === 5 && !formularioValido}
                                    helperText={idFiscal === "" && tipoPersonaId === 5 && !formularioValido ? `${traducirLabel(25)}` : ''}
                                    inputProps={{ maxLength: 256 }} 
                                    disabled={isDisabledNRF}/>
                            </Grid>

                            <Grid item xs={12}>
                                <FormControl required={tipoPersonaId == 5} fullWidth variant="outlined" className={classes.padding}
                                    error={tipoPersonaId == 5 && !residenciaFiscalId && !formularioValido}>
                                    <InputLabel htmlFor="residenciaFiscal" >
                                        {/* Residencia Fiscal */
                                            traducirLabel(263)}
                                    </InputLabel>
                                    <Select
                                        id="residenciaFiscal"
                                        onChange={handleChangeResidenciaFiscal}
                                        value={residenciaFiscalId || "0"}
                                        disabled={isDisabledNRF}
                                    >
                                        <MenuItem key={0} value={0}>
                                            {/* --Seleccione-- */
                                                traducirLabel(323)}
                                        </MenuItem>
                                        {residenciasFiscales != null && residenciasFiscales.map((option) => (
                                            <MenuItem key={option.clave} value={option.clave}>
                                                {option.descripcion}
                                            </MenuItem>
                                        ))}

                                    </Select>
                                    <FormHelperText error >
                                        {tipoPersonaId === 5 && !residenciaFiscalId && !formularioValido ? `${traducirLabel(25)}` : ''}
                                    </FormHelperText>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Container>
                </DialogContentText>
            </DialogContent>

            <DialogActions>
                <Button onClick={cerrar} color="secondary">
                    {/* Cancelar */
                        traducirButton(6)}
                </Button>
                <Button variant="contained" onClick={validarDatos} color="primary">
                    {/* Continuar */
                        traducirButton(7)}
                </Button>
            </DialogActions>
        </Dialog>

    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    ayuda: state.ayuda
});

const mapDispatchToProps = {
};

export default connect(mapStateToProps, mapDispatchToProps)(DatosComplementarios);



